import React from 'react';
import cn from 'classnames';

import {useContentCardContext} from '../../ContentCard';

import {IContentCardSubtitlesProps} from './IContentCardSubtitles';

import styles from './ContentCardSubtitles.module.scss';

const ContentCardSubtitles = (props: IContentCardSubtitlesProps) => {
	const {style} = useContentCardContext();

	return (
		<div className={cn(styles['content-card__subtitles'], {[styles[`content-card__subtitles--${style}`]]: style})}>
			{props.children}
		</div>
	);
};

export default ContentCardSubtitles;
